export const GET_PROGRESS_DATA = 'GET_PROGRESS_DATA'
export const GET_EMPTY_PROFILE = 'GET_EMPTY_PROFILE'
